import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { Observable } from 'rxjs';
import { CardTokenStore, CardTokenState } from './card-token.store';
import { CardToken } from './models/card-token.model';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CardTokenQuery extends QueryEntity<CardTokenState> {
  constructor(protected store: CardTokenStore) {
    super(store);
  }

  /** All card tokens. */
  selectCard(): Observable<CardToken[]> {
    return this.selectAll();
  }

  /** The default card token. */
  selectDefaultCard(): Observable<CardToken> {
    return (this.selectActive() as Observable<CardToken | CardToken[]>).pipe(
      map(x => (Array.isArray(x) ? x[0] : x))
    );
  }

  /** All card tokens except the default card token. */
  selectExceptDefaultCard(): Observable<CardToken[]> {
    return this.selectAll({ filterBy: entity => !entity.IsDefaultToken });
  }

  /** All frozen card tokens. */
  selectFrozenCards(): Observable<CardToken[]> {
    return this.selectAll({ filterBy: card => card.Frozen });
  }

  /** All unfrozen card tokens. */
  selectUnfrozenCards(): Observable<CardToken[]> {
    return this.selectAll({ filterBy: card => !card.Frozen });
  }

  /** All expired card tokens. */
  selectExpiredCards(): Observable<CardToken[]> {
    return this.selectAll({
      filterBy: card => {
        if (!card.ExpiryDate) {
          return false;
        }

        return new Date(card.ExpiryDate) < new Date();
      }
    });
  }

  /** All unexpired card tokens. */
  selectUnexpiredCards(): Observable<CardToken[]> {
    return this.selectAll({
      filterBy: card => {
        if (!card.ExpiryDate) {
          return true;
        }

        return new Date(card.ExpiryDate) >= new Date();
      }
    });
  }
}
